import { render, staticRenderFns } from "./UniformConfigCustomInfo.vue?vue&type=template&id=5706bd81"
import script from "./UniformConfigCustomInfo.vue?vue&type=script&lang=js"
export * from "./UniformConfigCustomInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports